// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3n4dD","content":"styles_content__1N_Wf"};